import { React } from 'react'
import { motion } from 'framer-motion'

import './Services.scss'

import { useDocumentTitle, useDocumentConfig } from 'hooks/useDocument'

import Hero from 'modules/Hero'
import Button from 'components/Button'
import ServicesList from 'components/ServicesList'

const Services = () => {
	useDocumentTitle(`Offres et services`)
	useDocumentConfig(`blue`, false)

	return (
		<motion.main
			className='services'
			initial={{ opacity: 0, transition: { duration: 0.3 } }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0, transition: { duration: 0.3 } }}
		>
			<Hero
				scene={3}
				scrollTo='Découvrir nos services'
			>
				Offres et
				<br />
				services
			</Hero>

			<section className='services-offers'>
				<h2 className='align-center'>Nos offres adaptées à vos besoins</h2>
				<div className='columns services-offers-list'>
					<div className='column-third'>
						<div className='offer-card'>
							<h3>Site clé en main</h3>
							<ul className='offer-features no-prefix'>
								<li>Site sur-mesure, compatible tous écrans</li>
								<li>5 pages, extensible selon vos besoins</li>
								<li>Référencement Google optimisé</li>
								<li>Hébergement + nom de domaine inclus</li>
								<li>Formation simple à l'édition</li>
								<li>Livraison en 4 à 6 semaines</li>
							</ul>
							<div className='offer-price'>
								<strong>3500 à 5000€&nbsp;HT</strong>
							</div>
						</div>
					</div>
					<div className='column-third'>
						<div className='offer-card offer-card--premium'>
							<h3>Refonte Premium</h3>
							<ul className='offer-features no-prefix'>
								<li>Analyse UX parcours clients</li>
								<li>Direction artistique sur-mesure</li>
								<li>Développement sur-mesure</li>
								<li>Architecture évolutive</li>
								<li>Documentation & formation</li>
							</ul>
							<div className='offer-price'>
								<strong>à partir de 6000€&nbsp;HT</strong>
							</div>
						</div>
					</div>
					<div className='column-third'>
						<div className='offer-card'>
							<h3>Intégration Front</h3>
							<ul className='offer-features no-prefix'>
								<li>Intégration de vos maquettes (Figma, Adobe XD, etc.)</li>
								<li>Respect des chartes graphiques</li>
								<li>Structure modulaire et évolutive</li>
								<li>Animations et interactions fluides</li>
								<li>Site rapide et fiable</li>
							</ul>
							<div className='offer-price'>
								<strong>TJM 450–500€</strong>
							</div>
						</div>
					</div>
				</div>
			</section>

			<div className='column-full align-center'>
				<Button
					to={`${process.env.PUBLIC_URL}/nous-contacter`}
					version='1'
				>
					Nous contacter
				</Button>
			</div>

			<hr />

			<ServicesList />

		<div className='column-full align-center'>
				<Button
					to={`${process.env.PUBLIC_URL}/nous-contacter`}
					version='1'
				>
					Nous contacter
				</Button>
			</div>
		</motion.main>
	)
}

export default Services
